import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-[#23242A] text-white h-screen appheader p-3",
  id: "content_screen"
}
const _hoisted_2 = { class: "p-3 flex content-main" }
const _hoisted_3 = { class: "custom-full" }
const _hoisted_4 = { class: "bg-[#2B2C32] rounded-lg max-w-full mb-[80px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_GeneralProfile = _resolveComponent("GeneralProfile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Nav, { activeTab: "Profile" }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_GeneralProfile)
        ])
      ])
    ])
  ]))
}